import { Link } from 'react-router-dom';
import DB from '../data/mockData';

const STARS = ['', '⭐', '⭐⭐', '⭐⭐⭐', '⭐⭐⭐⭐'];

export default function Opportunities() {
  return (
    <div className="content">
      {/* Banner */}
      <div className="d-flex align-items-center gap-3 p-3 rounded-4 flex-wrap" style={{ background: 'linear-gradient(135deg,#0c2f45,#1a5e7d)' }}>
        <div className="fo-banner-ico">🎯</div>
        <div className="flex-grow-1 text-white" style={{ fontSize: '12.5px', lineHeight: 1.5, opacity: .92 }}>
          <strong style={{ color: '#7DD6F0' }}>Nova identified {DB.opportunities.length} in-licensing opportunities</strong> — products active in ≥2 EU markets, absent from all NL supplier lists. Ranked by estimated NL revenue.
        </div>
        <Link to="/bc/editor" className="btn btn-s btn-sm" style={{ background: 'rgba(255,255,255,.12)', border: '1px solid rgba(255,255,255,.2)', color: '#fff' }}>Generate BC →</Link>
      </div>

      {/* Table card */}
      <div className="card">
        <div className="ch">
          <div className="ch-ico">⚡</div>
          <div><div className="ch-title">NL Market Gaps — Cross-Supplier</div></div>
          <div className="ch-act ms-auto">
            <span className="ai-badge">✦ Nova</span>
            <button className="btn btn-s btn-sm">↓ Export</button>
          </div>
        </div>
        <div className="table-responsive">
          <table className="tbl">
            <thead>
              <tr>
                <th>Product</th>
                <th className="d-none d-md-table-cell">Molecule</th>
                <th className="d-none d-sm-table-cell">Supplier</th>
                <th className="d-none d-lg-table-cell">Available In</th>
                <th>NL Status</th>
                <th className="d-none d-md-table-cell">Signal</th>
                <th>Est. Potential</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {DB.opportunities.map((o, i) => (
                <tr key={i}>
                  <td><strong>{o.product}</strong></td>
                  <td className="d-none d-md-table-cell" style={{ color: 'var(--t3)' }}>{o.mol}</td>
                  <td className="d-none d-sm-table-cell">{o.supplier}</td>
                  <td className="d-none d-lg-table-cell">
                    <div className="d-flex flex-wrap gap-1">{o.markets.map((m, j) => <span key={j} className="pill p-t">{m}</span>)}</div>
                  </td>
                  <td><span className={`pill ${o.nlStatus.includes('MA') ? 'p-a' : 'p-r'}`}>{o.nlStatus}</span></td>
                  <td className="d-none d-md-table-cell"><span className={`pill ${o.signal >= 3 ? 'p-r' : o.signal === 2 ? 'p-a' : 'p-t'}`}>{STARS[o.signal]}</span></td>
                  <td style={{ fontWeight: 700, color: 'var(--green)' }}>{o.potential}</td>
                  <td><Link to="/bc/editor" className="btn btn-p btn-xs">→ BC</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
